import types from './types';

const toggle = state => ({
  type: types.COMPARE_ROWS_MODAL,
  state: state || false
});

const getFullRows = (ids, entityType) => ({
  type: types.GET_FULL_ROWS,
  params: { ids, entityType }
});

export default {
  toggle,
  getFullRows
};

export const actions = {
  toggle,
  getFullRows
};
